export default __webpack_public_path__ + "static/media/(32).8af5c3bc.jpg";